export const PHONE_DISPLAY = "(571) 717-2357";
export const PHONE_TEL = "tel:+15717172357";
export const BOOKING_URL = "https://calendar.app.google/XS5MLVbSkn8v2cBR6";
